
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { tokens } from "../../../../../theme";
import Loader from '../loader/Loader';
import LeaveHistory from './LeaveHistory';
import { getAuth } from "firebase/auth";
function AppAutoComplete() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [data, setData] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [message, setMessage] = useState('');
  const [showAddLeaves, setShowAddLeaves] = useState(false);
  const [showDeductLeaves, setShowDeductLeaves] = useState(false);
  const [showUpdatelwp, setShowUpdatelwp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  // Add to state declarations
const [showHistory, setShowHistory] = useState(false);
const [historyData, setHistoryData] = useState([]);
const [historyOperation, setHistoryOperation] = useState('');

// Add fetchHistory function
const fetchHistory = (operation) => {
  setLoading(true);
  fetch(
    `${process.env.REACT_APP_BACKEND_URL_LMS}/leavehistory?UserEmail=${selectedUsers[0]}&Operation=${operation}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
    .then(response => response.json())
    .then(data => {
      setHistoryData(data);
      setShowHistory(true);
      setHistoryOperation(operation);
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      setMessage('Error fetching history');
    });
};
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setLoading(true);
    fetch(
      `${process.env.REACT_APP_BACKEND_URL_LMS}/annualleave`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      }
    )
      .then(response => response.json())
      .then(data => {
        // Process the data to ensure unique entries based on email
        const uniqueData = removeDuplicatesByEmail(data);
        setData(uniqueData);
        setLoading(false);
      });
  };

  // Function to remove duplicate entries based on email
  const removeDuplicatesByEmail = (data) => {
    const emailMap = {};
    return data.filter(item => {
      if (!emailMap[item.useremail]) {
        emailMap[item.useremail] = true;
        return true;
      }
      return false;
    });
  };

  const handleCheckboxChange = (event) => {
    const userEmail = event.target.value;
    if (event.target.checked) {
      setSelectedUsers([...selectedUsers, userEmail]);
    } else {
      setSelectedUsers(selectedUsers.filter(user => user !== userEmail));
    }
  };

  const handleAddLeavesClick = () => {
    setShowAddLeaves(true);
    setShowDeductLeaves(false);
    setShowUpdatelwp(false);
    if (selectedUsers.length === 1) {
      fetchHistory('ADD');
    }
  };

  const handleDeductLeavesClick = () => {
    setShowAddLeaves(false);
    setShowDeductLeaves(true);
    setShowUpdatelwp(false);
    if (selectedUsers.length === 1) {
      fetchHistory('DEDUCT');
    }
  };

  const handleFocus = (value, setter) => {
    if (value === '0') setter('');
  };

  const handleBlur = (value, setter) => {
    if (value === '') setter('0');
  };

  const handleUpdatelwpClick = () => {
    setShowAddLeaves(false);
    setShowDeductLeaves(false);
    setShowUpdatelwp(true);
    if (selectedUsers.length === 1) {
      fetchHistory('UPDATE');
    }
  };

  // Pagination Logic
  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = data.slice(indexOfFirstEntry, indexOfLastEntry);
  const totalPages = Math.ceil(data.length / entriesPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleEntriesPerPageChange = (event) => {
    setEntriesPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  return (
    <Box m="20px">
      <Typography 
        variant="h2" 
        color={colors.grey[100]} 
        fontWeight="bold" 
        sx={{ mb: "20px", textAlign: "center" }}
      >
        Add & Deduct Leaves
      </Typography>

      {/* Entries Per Page Dropdown */}
      <Box display="flex" justifyContent="flex-end" mb="20px">
        <FormControl variant="outlined" size="small" sx={{ minWidth: 150 }}>
          <InputLabel 
            sx={{
              color: colors.grey[100],
              fontWeight: "bold",
              fontSize: "18px",
              "&.Mui-focused": {
                color: colors.grey[100],     
              },
              "&.MuiInputLabel-shrink": {
                color: colors.grey[100],    
              },
            }}
          >Show</InputLabel>
          <Select
            value={entriesPerPage}
            onChange={handleEntriesPerPageChange}
            label="Show"
            sx={{
               color: colors.grey[100],
                borderRadius: "8px",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.grey[100],   
                  borderWidth: "1.5px",           
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.greenAccent[500],  
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.greenAccent[500], 
                  borderWidth: "1.5px",
                },
                "& .MuiSvgIcon-root": {
                  color: colors.grey[100],  
                },
              }}
          >
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <TableContainer sx={{ backgroundColor: colors.primary[400], borderRadius: "4px" }}>
  <Table size="small">  {/* Add size="small" prop to Table */}
    <TableHead>
      <TableRow sx={{ 
        backgroundColor: colors.blueAccent[700],
        '& .MuiTableCell-root': {  // Target all TableCells in the header row
          padding: '4px 8px',      // Reduce padding
          color: colors.grey[100], 
          fontWeight: "bold",
          lineHeight: '4',       // Reduce line height
        }
      }}>
        <TableCell>Select</TableCell>
        <TableCell>User Name</TableCell>
        <TableCell>Email</TableCell>
        <TableCell>EL</TableCell>
        <TableCell>PL</TableCell>
        <TableCell>Total Leave</TableCell>
        <TableCell>LWP</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {currentEntries.map(row => (
        <TableRow 
          key={row.useremail} 
          sx={{ 
            '&:hover': { backgroundColor: colors.grey[800] },
            '& .MuiTableCell-root': {  // Target all TableCells in the body row
              padding: '4px 8px',     // Reduce padding
              lineHeight: '2.5',      // Reduce line height
              color: colors.grey[100],
            },
            height: '50px',           // Set explicit height
          }}
        >
          <TableCell>
            <Checkbox 
              value={row.useremail} 
              onChange={handleCheckboxChange}
              size="small"            // Add size="small" to Checkbox
              sx={{
                color: colors.greenAccent[500],
                '&.Mui-checked': {
                  color: colors.greenAccent[500],
                },
                padding: '4px',       // Reduce checkbox padding
              }}
            />
          </TableCell>
          <TableCell>{row.username}</TableCell>
          <TableCell>{row.useremail}</TableCell>
          <TableCell>{row.emergencyleave}</TableCell>
          <TableCell>{row.plannedleave}</TableCell>
          <TableCell>{row.annualleave}</TableCell>
          <TableCell>{row.leavewithoutpay}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
</TableContainer>

      {/* Pagination Controls */}
      <Box display="flex" justifyContent="center" alignItems="center" mt="20px">
        <Button 
          onClick={handlePreviousPage} 
          disabled={currentPage === 1}
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: colors.grey[100],
            '&:hover': {
              backgroundColor: colors.blueAccent[800],
            },
            '&:disabled': {
              backgroundColor: colors.grey[700],
              color: colors.grey[500]
            }
          }}
        >
          Previous
        </Button>
        <Typography variant="body1" sx={{ mx: "20px", color: colors.grey[100] }}>
          Page {currentPage} of {totalPages}
        </Typography>
        <Button 
          onClick={handleNextPage} 
          disabled={currentPage === totalPages}
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: colors.grey[100],
            '&:hover': {
              backgroundColor: colors.blueAccent[800],
            },
            '&:disabled': {
              backgroundColor: colors.grey[700],
              color: colors.grey[500]
            }
          }}
        >
          Next
        </Button>
      </Box>

      {selectedUsers.length > 0 && (
        <Box display="flex" justifyContent="center" mt="20px" gap="20px">
          <Button 
            onClick={handleAddLeavesClick}
            sx={{
              backgroundColor: colors.greenAccent[700],
              color: colors.grey[100],
              '&:hover': {
                backgroundColor: colors.greenAccent[800],
              }
            }}
          >
            Add Leaves
          </Button>
          <Button 
            onClick={handleDeductLeavesClick}
            sx={{
              backgroundColor: colors.redAccent[700],
              color: colors.grey[100],
              '&:hover': {
                backgroundColor: colors.redAccent[800],
              }
            }}
          >
            Deduct Leaves
          </Button>
          <Button 
            onClick={handleUpdatelwpClick}
            sx={{
              backgroundColor: colors.blueAccent[700],
              color: colors.grey[100],
              '&:hover': {
                backgroundColor: colors.blueAccent[800],
              }
            }}
          >
            Update LWP
          </Button>
        </Box>
      )}

      {showAddLeaves && (
        <Box mt="20px">
          <AddLeaves 
            selectedUsers={selectedUsers} 
            setMessage={setMessage} 
            fetchData={fetchData} 
            colors={colors}
          />
        </Box>
      )}
      {showDeductLeaves && (
        <Box mt="20px">
          <DeductLeaves 
            selectedUsers={selectedUsers} 
            setMessage={setMessage} 
            fetchData={fetchData} 
            colors={colors}
          />
        </Box>
      )}
      {showUpdatelwp && (
        <Box mt="20px">
          <Updatelwp 
            selectedUsers={selectedUsers} 
            setMessage={setMessage} 
            fetchData={fetchData} 
            colors={colors}
          />
        </Box>
      )}

      {message && (
        <Typography 
          variant="body1" 
          sx={{ 
            mt: "20px", 
            textAlign: "center", 
            color: colors.greenAccent[500] 
          }}
        >
          {message}
        </Typography>
      )}
      {showHistory && (
      <LeaveHistory 
        historyData={historyData} 
        operation={historyOperation} 
        colors={colors} 
      />
    )}
    </Box>
  );
}

function AddLeaves({ selectedUsers, setMessage, fetchData, colors }) {
  const [emergencyLeave, setEmergencyLeave] = useState(0);
  const [plannedLeave, setPlannedLeave] = useState(0);
  const [comment, setComment] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [localMessage, setLocalMessage] = useState(''); // Add local state for message
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  const [showHistory, setShowHistory] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [historyOperation, setHistoryOperation] = useState('');
  
  // Add fetchHistory function
  const fetchHistory = (operation) => {
    setIsLoading(true);
    fetch(
      `${process.env.REACT_APP_BACKEND_URL_LMS}/leavehistory?UserEmail=${selectedUsers[0]}&Operation=${operation}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      }
    )
      .then(response => response.json())
      .then(data => {
        setHistoryData(data);
        setShowHistory(true);
        setHistoryOperation(operation);
        setIsLoading(false);
      })
      .catch(error => {
        setIsLoading(false);
        setMessage('Error fetching history');
      });
  };
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission
    if (!comment.trim()) {
      setLocalMessage('Comment is required'); // Use local state to set message
      return;
    }
    setIsLoading(true);
    setLocalMessage(''); // Clear previous message on successful submission

    const auth = getAuth();
    const user = auth.currentUser;
    const updatedBy = user?.email || "Admin";
    const data = selectedUsers.map(userEmail => ({
      UserEmail: userEmail,
      emergencyleave: Number(emergencyLeave),
      plannedleave: Number(plannedLeave),
      comment: comment.trim(),
      added_by: updatedBy
    }));
    fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/addleaves`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        setMessage(data.message); // Use setMessage prop to update parent state
        fetchData();
        setEmergencyLeave(0);
        setPlannedLeave(0);
        setComment('');
      })
      .catch(error => {
        setLocalMessage('An error occurred. Please try again.');
      })
      .finally(() => setIsLoading(false));
  };
  const handleFocus = (value, setter) => {
      if (value === 0 || value === '0') {
        setter('');
      }
    };

    const handleBlur = (value, setter) => {
      if (value === '') setter(0);
    };

  return (
    <Box
      sx={{
        backgroundColor: colors.primary[400],
        p: "20px",
        borderRadius: "4px",
        maxWidth: "500px",
        mx: "auto"
      }}
    >
      {isLoading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            backdropFilter: "blur(5px)"
          }}
        >
          <Loader />
        </Box>
      )}

      {selectedUsers.length > 0 && (
        <>
          <Typography variant="h3" sx={{ mb: "20px", color: colors.grey[100], textAlign: "center" }}>
            Add Leaves
          </Typography>
          <form onSubmit={handleSubmit} noValidate>
            <Box mb="20px">
              <Typography variant="h5" sx={{ mb: "10px", color: colors.grey[100] }}>
                Emergency Leave:
              </Typography>
              <input 
                type="number" 
                value={emergencyLeave} 
                onFocus={() => handleFocus(emergencyLeave, setEmergencyLeave)}
                onBlur={() => handleBlur(emergencyLeave, setEmergencyLeave)}
                onChange={event => setEmergencyLeave(event.target.value)} 
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: `1px solid ${colors.grey[700]}`,
                  backgroundColor: colors.primary[400],
                  color: colors.grey[100]
                }}
              />
            </Box>
            <Box mb="20px">
              <Typography variant="h5" sx={{ mb: "10px", color: colors.grey[100] }}>
                Planned Leave:
              </Typography>
              <input 
                type="number" 
                value={plannedLeave} 
                onChange={event => setPlannedLeave(event.target.value)} 
                onFocus={() => handleFocus(plannedLeave, setPlannedLeave)}
                onBlur={() => handleBlur(plannedLeave, setPlannedLeave)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: `1px solid ${colors.grey[700]}`,
                  backgroundColor: colors.primary[400],
                  color: colors.grey[100]
                }}
              />
            </Box>
            <Box mb="20px">
              <Typography variant="h5" sx={{ mb: "10px", color: colors.grey[100] }}>
                Comment:
              </Typography>
              <input 
                type="text" 
                value={comment} 
                onChange={event => setComment(event.target.value)} 
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: `1px solid ${colors.grey[700]}`,
                  backgroundColor: colors.primary[400],
                  color: colors.grey[100]
                }}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <Button 
                type="submit"
                sx={{
                  backgroundColor: colors.greenAccent[700],
                  color: colors.grey[100],
                  '&:hover': {
                    backgroundColor: colors.greenAccent[800],
                  }
                }}
              >
                Add
              </Button>
            </Box>
          </form>
          {localMessage && ( // Use localMessage to display validation errors
            <Typography 
              variant="body1" 
              sx={{ 
                mt: "10px", 
                textAlign: "center", 
                color: colors.redAccent[500] 
              }}
            >
              {localMessage}
            </Typography>
          )}
        </>
      )}
      {showHistory && (
      <LeaveHistory 
        historyData={historyData} 
        operation={historyOperation} 
        colors={colors} 
      />
    )}
    </Box>
  );
}
function DeductLeaves({ selectedUsers, setMessage, fetchData, colors }) {
  const [emergencyLeave, setEmergencyLeave] = useState(0);
  const [plannedLeave, setPlannedLeave] = useState(0);
  const [comment, setComment] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [localMessage, setLocalMessage] = useState(''); // Add local state for message
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission
    if (!comment.trim()) {
      setLocalMessage('Comment is required'); // Use local state to set message
      return;
    }
    setIsLoading(true);
    setLocalMessage(''); // Clear previous message on successful submission
    const auth = getAuth();
    const user = auth.currentUser;
    const updatedBy = user?.email || "Admin";
    const data = selectedUsers.map(userEmail => ({
      UserEmail: userEmail,
      emergencyleave: Number(emergencyLeave),
      plannedleave: Number(plannedLeave),
      comment: comment.trim(),
      added_by: updatedBy
    }));
    fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/deductleaves`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        setMessage(data.message); // Use setMessage prop to update parent state
        fetchData();
        setEmergencyLeave(0);
        setPlannedLeave(0);
        setComment('');
      })
      .catch(error => {
        setLocalMessage('An error occurred. Please try again.');
      })
      .finally(() => setIsLoading(false));
  };
    const handleFocus = (value, setter) => {
      if (value === 0 || value === '0') {
        setter('');
      }
    };

    const handleBlur = (value, setter) => {
      if (value === '') setter(0);
    };
  return (
    <Box
      sx={{
        backgroundColor: colors.primary[400],
        p: "20px",
        borderRadius: "4px",
        maxWidth: "500px",
        mx: "auto"
      }}
    >
      {isLoading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            backdropFilter: "blur(5px)"
          }}
        >
          <Loader />
        </Box>
      )}

      {selectedUsers.length > 0 && (
        <>
          <Typography variant="h3" sx={{ mb: "20px", color: colors.grey[100], textAlign: "center" }}>
            Deduct Leaves
          </Typography>
          <form onSubmit={handleSubmit} noValidate>
            <Box mb="20px">
              <Typography variant="h5" sx={{ mb: "10px", color: colors.grey[100] }}>
                Emergency Leave:
              </Typography>
              <input 
                type="number" 
                value={emergencyLeave} 
                onChange={event => setEmergencyLeave(event.target.value)} 
                onFocus={() => handleFocus(emergencyLeave, setEmergencyLeave)}
                onBlur={() => handleBlur(emergencyLeave, setEmergencyLeave)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: `1px solid ${colors.grey[700]}`,
                  backgroundColor: colors.primary[400],
                  color: colors.grey[100]
                }}
              />
            </Box>
            <Box mb="20px">
              <Typography variant="h5" sx={{ mb: "10px", color: colors.grey[100] }}>
                Planned Leave:
              </Typography>
              <input 
                type="number" 
                value={plannedLeave} 
                onChange={event => setPlannedLeave(event.target.value)} 
                onFocus={() => handleFocus(plannedLeave, setPlannedLeave)}
                onBlur={() => handleBlur(plannedLeave, setPlannedLeave)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: `1px solid ${colors.grey[700]}`,
                  backgroundColor: colors.primary[400],
                  color: colors.grey[100]
                }}
              />
            </Box>
            <Box mb="20px">
              <Typography variant="h5" sx={{ mb: "10px", color: colors.grey[100] }}>
                Comment:
              </Typography>
              <input 
                type="text" 
                value={comment} 
                onChange={event => setComment(event.target.value)} 
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: `1px solid ${colors.grey[700]}`,
                  backgroundColor: colors.primary[400],
                  color: colors.grey[100]
                }}
              />
            </Box>
            {localMessage && ( // Use localMessage to display validation errors
            <Typography 
              variant="body1" 
              sx={{ 
                m: "10px", 
                textAlign: "center", 
                color: colors.redAccent[500] 
              }}
            >
              {localMessage}
            </Typography>
          )}
            <Box display="flex" justifyContent="center">
              <Button 
                type="submit"
                sx={{
                  backgroundColor: colors.redAccent[700],
                  color: colors.grey[100],
                  '&:hover': {
                    backgroundColor: colors.redAccent[800],
                  }
                }}
              >
                Deduct
              </Button>
            </Box>
          </form>
        </>
      )}
    </Box>
  );
}

function Updatelwp({ selectedUsers, setMessage, fetchData, colors }) {
  const [leavewithoutpay, setleavewithoutpay] = useState(0);
  const [comment, setComment] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [localMessage, setLocalMessage] = useState(''); // Add local state for message
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
// Add to state declarations
const [showHistory, setShowHistory] = useState(false);
const [historyData, setHistoryData] = useState([]);
const [historyOperation, setHistoryOperation] = useState('');

// Add fetchHistory function
const fetchHistory = (operation) => {
  setIsLoading(true);
  fetch(
    `${process.env.REACT_APP_BACKEND_URL_LMS}/leavehistory?UserEmail=${selectedUsers[0]}&Operation=${operation}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
    .then(response => response.json())
    .then(data => {
      setHistoryData(data);
      setShowHistory(true);
      setHistoryOperation(operation);
      setIsLoading(false);
    })
    .catch(error => {
      setIsLoading(false);
      setMessage('Error fetching history');
    });
};
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission
    if (!comment.trim()) {
      setLocalMessage('Comment is required'); // Use local state to set message
      return;
    }
    const auth = getAuth();
    const user = auth.currentUser;
    const updatedBy = user?.email || "Admin";
    setIsLoading(true);
    setLocalMessage(''); // Clear previous message on successful submission
    const data = selectedUsers.map(userEmail => ({
      UserEmail: userEmail,
      leavewithoutpay: Number(leavewithoutpay),
      comment: comment.trim(),
      added_by: updatedBy
    }));
    fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/updatelwp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        setMessage(data.message); // Use setMessage prop to update parent state
        fetchData();
        setleavewithoutpay(0);
        setComment(''); 
      })
      .catch(error => {
        setLocalMessage('An error occurred. Please try again.');
      })
      .finally(() => setIsLoading(false));
  };

   const handleFocus = (value, setter) => {
      if (value === 0 || value === '0') {
        setter('');
      }
    };

    const handleBlur = (value, setter) => {
      if (value === '') setter(0);
    };

  return (
    <Box
      sx={{
        backgroundColor: colors.primary[400],
        p: "20px",
        borderRadius: "4px",
        maxWidth: "500px",
        mx: "auto"
      }}
    >
      {isLoading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            backdropFilter: "blur(5px)"
          }}
        >
          <Loader />
        </Box>
      )}

      {selectedUsers.length > 0 && (
        <>
          <Typography variant="h3" sx={{ mb: "20px", color: colors.grey[100], textAlign: "center" }}>
            Update LWP
          </Typography>
          <form onSubmit={handleSubmit} noValidate>
            <Box mb="20px">
              <Typography variant="h5" sx={{ mb: "10px", color: colors.grey[100] }}>
                Leave Without Pay:
              </Typography>
              <input 
                type="number" 
                value={leavewithoutpay} 
                onChange={event => setleavewithoutpay(event.target.value)} 
                  onFocus={() => handleFocus(leavewithoutpay, setleavewithoutpay)}
                onBlur={() => handleBlur(leavewithoutpay, setleavewithoutpay)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: `1px solid ${colors.grey[700]}`,
                  backgroundColor: colors.primary[400],
                  color: colors.grey[100]
                }}
              />
            </Box>
            <Box mb="20px">
              <Typography variant="h5" sx={{ mb: "10px", color: colors.grey[100] }}>
                Comment:
              </Typography>
              <input 
                type="text" 
                value={comment} 
                onChange={event => setComment(event.target.value)} 
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: `1px solid ${colors.grey[700]}`,
                  backgroundColor: colors.primary[400],
                  color: colors.grey[100]
                }}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <Button 
                type="submit"
                sx={{
                  backgroundColor: colors.blueAccent[700],
                  color: colors.grey[100],
                  '&:hover': {
                    backgroundColor: colors.blueAccent[800],
                  }
                }}
              >
                Update
              </Button>
            </Box>
          </form>
          {localMessage && ( // Use localMessage to display validation errors
            <Typography 
              variant="body1" 
              sx={{ 
                mt: "10px", 
                textAlign: "center", 
                color: colors.redAccent[500] 
              }}
            >
              {localMessage}
            </Typography>
          )}
        </>
      )}
      {showHistory && (
      <LeaveHistory 
        historyData={historyData} 
        operation={historyOperation} 
        colors={colors} 
      />
    )}
    </Box>
  );
}

export default AppAutoComplete;